import type { ReactNode } from 'react';

export const symbol_highlight: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m204-676-43-42q-9-9-9-21t8.61-21q9.39-9 21.89-9t21.5 9l42 42q8 9 8.5 21.1.5 12.1-8.5 20.9-9 9-21 8.5t-21-8.5Zm246-114v-60q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v60q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37Zm264 73 43-43q9-8 21.1-8 12.1 0 20.9 9 9 9 9 21t-9 21l-43 43q-9 9-21 9t-21-8.61q-9-9.39-9-21.96 0-12.56 9-21.43ZM360-140v-140L258-382q-8-8-13-19.28-5-11.28-5-23.72v-115q0-24.75 17.63-42.38Q275.25-600 300-600h360q24.75 0 42.38 17.62Q720-564.75 720-540v115q0 12.44-5 23.72T702-382L600-280v140q0 24.75-17.62 42.37Q564.75-80 540-80H420q-24.75 0-42.37-17.63Q360-115.25 360-140Zm60 0h120v-165l120-120v-115H300v115l120 120v165Zm60-200Z"
		/>
	</svg>
);
